export default {"src":"/_next/static/media/clock-icon.c7a46c6e.svg","height":14,"width":14};